<!--
  File name: Ratings.vue
  Program Description:
    - This component will return a rating ranging from 1 to 5, depending on the user input.
-->
<template>
  <v-container>
    <v-row>
      <v-col class="d-flex pb-0">
        <span class="mr-5">
          <b>{{ title }}: </b>
          {{ subtitle }}
        </span>
        <v-scroll-x-transition v-if="errorMessage">
          <p
            v-show="errorMessage.show"
            :style="{
              color: 'rgb(255, 82, 82)',
              fontWeight: '700',
              margin: 0
            }"
          >
            {{ errorMessage.value }}
          </p>
        </v-scroll-x-transition>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="digit in 5"
        :key="digit"
        cols="2"
      >
        <v-btn
          x-large
          elevation="0"
          :class="{'disable-events': disabled}"
          :color="selected === digit || modelValue === digit ? 'primary' : ''"
          @click="modelValue = digit"
        >
          <h1>{{ digit }}</h1>
        </v-btn>
        <v-card-subtitle
          v-if="digit === 1"
          style="color: rgba(0, 0, 0, 0.5)"
          class="px-0"
        >
          Lowest
        </v-card-subtitle>
        <v-card-subtitle
          v-if="digit === 5"
          style="color: rgba(0, 0, 0, 0.5)"
          class="px-0 text-center"
        >
          Highest
        </v-card-subtitle>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Ratings',
  props: {
    value: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    selected: 0
  }),
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (val) {
        this.selected = val
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
.disable-events {
  pointer-events: none
}
</style>
